import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IGestifyCredential,
  IListGestifyCredentialFetchParams,
  MN_GESTIFY_CREDENTIALS,
} from '@jobcost-monorepo/crud';

export default function GestifyCredentialsPage() {
  return (
    <Grid<IGestifyCredential, IListGestifyCredentialFetchParams>
      moduleName={MN_GESTIFY_CREDENTIALS}
      updateStore={false}
    ></Grid>
  );
}
